// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Search from 'vant/lib/search'
import Popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
import 'vant/lib/search/style'
import axios from 'axios'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import store from './store';

Vue.prototype.$http=axios;
Vue.use(Search).use(Popup);
Vue.use(iView);

//全局配置API地址
Vue.prototype.API_ROOT = process.env.API_ROOT;
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
})



// WEBPACK FOOTER //
// ./src/main.js